import { combineReducers, configureStore } from "@reduxjs/toolkit";
import setManualTypeReducer from "./slice/manualTypeSlice";
import setSideMenuReducer from "./slice/sideMenuSlice";

const rootReducer = combineReducers({
  manualTypeChecker: setManualTypeReducer,
  sideMenuChecker: setSideMenuReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
